import { useQuery } from 'react-query';
import { getResult } from '../api/getResult';

const useResult = (query, personality, page, rowsPerPage, type, locale, filterExplicit, timeRange) => {
  const result = useQuery('search_'+ query+'_'+ personality.name+'_'+ page+'_'+ rowsPerPage+'_'+ type+'_'+ locale+'_'+ filterExplicit+'_'+ timeRange, () => getResult(query, personality, page, rowsPerPage, type, locale, filterExplicit, timeRange), {
    refetchOnWindowFocus: false,
    staleTime: 5000,
  });
  return result;
};

export default useResult;
